import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input, AfterContentChecked } from '@angular/core';

@Component({
  selector: 'seb-grid-tags',
  templateUrl: './grid-tags.component.html',
  styleUrls: ['./grid-tags.component.css']
})
export class GridTagsComponent implements OnInit {

  @ViewChild('grid') public grid: ElementRef;
  objTags: any;
  heightObj: any;
  @Input() tags: any;
  @Input() products: any;
  heightObjLimited: Number = 66;
  pointer: Boolean;
  heightAllObjs: Number = 0;

  constructor() { }

  ngOnInit() {
      const gridEl: HTMLCanvasElement = this.grid.nativeElement.clientHeight;
      this.heightObj = gridEl;
      if (this.tags) {
        if (this.tags.length <= 5) {
          this.pointer = false;
        } else {
        this.heightAllObjs = this.tags.length - 5;
        this.tags.splice(5);
        this.pointer = true;
        }
      } else if (this.products) {
        if (this.products.length <= 20) {
          this.pointer = false;
        } else {
        this.heightAllObjs = this.products.length - 20;
        this.products.splice(20);
        this.pointer = true;
        }
      }

  }
}
